import { render } from "./DeskReservationView.vue?vue&type=template&id=281e2c2b&scoped=true"
import script from "./DeskReservationView.vue?vue&type=script&lang=js"
export * from "./DeskReservationView.vue?vue&type=script&lang=js"

import "./DeskReservationView.vue?vue&type=style&index=0&id=281e2c2b&lang=css"
import "./DeskReservationView.vue?vue&type=style&index=1&id=281e2c2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281e2c2b"]])

export default __exports__